import { categoryByID, categoryCreate, categoryDestroy, categoryList, categoryUpdate } from '@/services/ventures/categories.service'

export default {
	namespaced: true,
	state: {
		categoryList: { meta: { pagination: { total: 0 } } },
		category: {},
		categoryStatus: 'pending',
		categorySaveStatus: 'init',
		categoryDeleteStatus: 'init',
	},
	getters: {
		getCategoryList: s => s.categoryList,
		getCategory: s => s.category,
		getCategoryStatus: s => s.categoryStatus,
		getCategorySaveStatus: s => s.categorySaveStatus,
		getCategoryDeleteStatus: s => s.categoryDeleteStatus,
	},
	mutations: {
		CATEGORY_LIST(state, value) { state.categoryList = value },
		SET_CATEGORY(state, value) { state.category = value },
		CATEGORY_STATUS(state, value) { state.categoryStatus = value },
		CATEGORY_SAVE_STATUS(state, value) { state.categorySaveStatus = value },
		CATEGORY_DELETE_STATUS(state, value) { state.categoryDeleteStatus = value },
	},
	actions: {
		async fetchCategoryList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('CATEGORY_STATUS', 'pending')
			commit('CATEGORY_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await categoryList(params)
				commit('CATEGORY_STATUS', 'init')
				commit('CATEGORY_LIST', data)
				return data
			} catch (error) {
				commit('CATEGORY_STATUS', 'init')
				throw error
			}
		},
		async fetchCategoryByID({ commit }, params) {
			commit('CATEGORY_STATUS', 'pending')
			try {
				const { data } = await categoryByID(params)
				commit('CATEGORY_STATUS', 'init')
				commit('SET_CATEGORY', data.data)
				return data
			} catch (error) {
				commit('CATEGORY_STATUS', 'init')
				return error
			}
		},
		async saveCategory({ commit }, params) {
			commit('CATEGORY_SAVE_STATUS', 'pending')
			try {
				const { data } = await categoryCreate(params)
				commit('CATEGORY_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('CATEGORY_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateCategory({ commit }, params) {
			commit('CATEGORY_SAVE_STATUS', 'pending')
			try {
				const { data } = await categoryUpdate(params)
				commit('CATEGORY_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('CATEGORY_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteCategoryByID({ commit }, params) {
			commit('CATEGORY_DELETE_STATUS', 'pending')
			try {
				const { data } = await categoryDestroy(params)
				commit('CATEGORY_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('CATEGORY_DELETE_STATUS', 'error')
				return error
			}
		},
	},
}
